module.exports = __webpack_public_path__ + "static/media/nfc-tag-grey.203edfb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/nfc-tag-grey.png
// module id = 649
// module chunks = 0